import { CompetitionInitService } from '../../services/competition-init.service';
import * as i0 from "@angular/core";
import * as i1 from "../../services/competition-init.service";
export class CompetitionDocumentsFilterService {
    constructor(competition_general_service) {
        this.competition_general_service = competition_general_service;
    }
    /**
     * Method for get the store wrapped.
     *
     * @readonly
     * @memberof CompetitionDocumentsFilterService
     */
    get store() {
        return this.competition_general_service.competitionDocumentsStore;
    }
    /**
     *
     *
     * @readonly
     * @memberof CompetitionDocumentsFilterService
     */
    get data() {
        return this.store.data && this.store.data[0] ? this.store.data[0] : undefined;
    }
}
CompetitionDocumentsFilterService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CompetitionDocumentsFilterService_Factory() { return new CompetitionDocumentsFilterService(i0.ɵɵinject(i1.CompetitionInitService)); }, token: CompetitionDocumentsFilterService, providedIn: "root" });
